var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadlight4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 141,
    viewBox: "0 0 209 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 209,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 76,
    height: 99,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.373 67.047H61.409V76H60.079V68.622C59.8457 68.7573 59.6077 68.8623 59.365 68.937C59.1223 69.007 58.8797 69.0467 58.637 69.056V67.768C58.9403 67.7307 59.2343 67.656 59.519 67.544C59.8083 67.4273 60.093 67.2617 60.373 67.047Z",
    fill: "#004552"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 21,
    width: 75,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 88,
    width: 75,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 55,
    width: 75,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.443 98.97H145.71V104.78H147.257V105.914H145.71V108H144.394V105.914H139.823V104.899L144.443 98.97ZM144.45 101L141.398 104.899H144.45V101Z",
    fill: "#004552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.239 41V39.593C140.239 39.0843 140.319 38.6573 140.477 38.312C140.636 37.962 140.867 37.6703 141.17 37.437C141.474 37.2037 141.842 37.003 142.276 36.835L144.068 36.135C144.498 35.9623 144.817 35.743 145.027 35.477C145.237 35.211 145.342 34.882 145.342 34.49C145.342 34.084 145.2 33.748 144.915 33.482C144.631 33.216 144.227 33.083 143.704 33.083C143.196 33.083 142.773 33.1997 142.437 33.433C142.106 33.6617 141.917 34.0047 141.87 34.462H140.393C140.417 33.9067 140.571 33.44 140.855 33.062C141.14 32.684 141.525 32.3993 142.01 32.208C142.496 32.0167 143.053 31.921 143.683 31.921C144.271 31.921 144.799 32.033 145.265 32.257C145.732 32.481 146.101 32.7913 146.371 33.188C146.647 33.5847 146.784 34.042 146.784 34.56C146.784 35.022 146.7 35.4257 146.532 35.771C146.364 36.1117 146.117 36.408 145.79 36.66C145.464 36.912 145.067 37.1313 144.6 37.318L142.78 38.039C142.37 38.1977 142.064 38.3843 141.863 38.599C141.667 38.809 141.569 39.0843 141.569 39.425V39.775H146.714V41H140.239Z",
    fill: "#004552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.531 75.182C143.074 75.182 142.633 75.119 142.208 74.993C141.784 74.8623 141.401 74.6757 141.06 74.433C140.724 74.1857 140.458 73.88 140.262 73.516C140.066 73.1473 139.968 72.7227 139.968 72.242H141.354C141.368 72.606 141.471 72.9163 141.662 73.173C141.854 73.4297 142.11 73.6257 142.432 73.761C142.754 73.8917 143.121 73.957 143.531 73.957C144.147 73.957 144.626 73.81 144.966 73.516C145.312 73.222 145.484 72.8533 145.484 72.41C145.484 72.1253 145.412 71.8757 145.267 71.661C145.127 71.4463 144.906 71.2807 144.602 71.164C144.304 71.0427 143.914 70.982 143.433 70.982H142.348V69.932H143.174C143.79 69.932 144.276 69.806 144.63 69.554C144.985 69.2973 145.162 68.9497 145.162 68.511C145.162 68.119 145.015 67.79 144.721 67.524C144.427 67.258 144 67.125 143.44 67.125C142.997 67.125 142.603 67.216 142.257 67.398C141.912 67.5753 141.683 67.895 141.571 68.357H140.192C140.262 67.7783 140.444 67.3093 140.738 66.95C141.032 66.5907 141.408 66.3293 141.865 66.166C142.323 66.0027 142.834 65.921 143.398 65.921C144.01 65.921 144.556 66.026 145.036 66.236C145.522 66.4413 145.902 66.7283 146.177 67.097C146.453 67.4657 146.59 67.8903 146.59 68.371C146.59 68.833 146.46 69.232 146.198 69.568C145.942 69.8993 145.566 70.1537 145.071 70.331C145.622 70.499 146.07 70.7673 146.415 71.136C146.761 71.5 146.933 71.962 146.933 72.522C146.933 73.04 146.793 73.4997 146.513 73.901C146.233 74.3023 145.839 74.6173 145.33 74.846C144.822 75.07 144.222 75.182 143.531 75.182Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlight4);
export default __webpack_public_path__ + "static/media/headlight-4.f206b3fc128ec5870d807ae057da9603.svg";
export { ForwardRef as ReactComponent };